import {
    Compass, Gem, Sunset, Receipt, LineChart, Shield, GraduationCap, Target, ArrowRight,
} from 'lucide-react';
import { TID } from '@/constants/testIds';
import { SERVICES } from '@/constants/content';

const ICONS = {
    compass: Compass, gem: Gem, sunset: Sunset, receipt: Receipt,
    'line-chart': LineChart, shield: Shield, 'graduation-cap': GraduationCap, target: Target,
};

export default function Services() {
    const go = () => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    return (
        <section id="services" className="section-pad bg-white">
            <div className="container-wl">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
                    <div className="max-w-2xl">
                        <div className="flex items-center gap-3 mb-5">
                            <span className="gold-rule" />
                            <span className="overline">Our Core Services</span>
                        </div>
                        <h2 className="font-display-bold text-ink text-4xl lg:text-[52px] leading-[1.05] tracking-tight">
                            Advisory across every stage of your financial life.
                        </h2>
                    </div>
                    <p className="text-ink/65 text-[15px] max-w-md lg:text-right">
                        Each engagement begins with listening — and ends with a written plan that fits
                        your goals, life stage and risk profile.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-hairline border border-hairline rounded-xl overflow-hidden">
                    {SERVICES.map((s) => {
                        const Icon = ICONS[s.icon] || Compass;
                        return (
                            <div
                                key={s.id}
                                data-testid={TID.serviceCard(s.id)}
                                className="group relative bg-white p-8 hover:bg-soft transition-colors duration-500"
                            >
                                <div className="w-12 h-12 flex items-center justify-center bg-gold-50 text-gold-600 group-hover:bg-navy group-hover:text-gold transition-colors">
                                    <Icon className="w-5 h-5" strokeWidth={1.5} />
                                </div>
                                <h3 className="font-display-bold text-ink text-[22px] mt-6 leading-tight">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-[14.5px] text-ink/65 leading-relaxed min-h-[64px]">
                                    {s.desc}
                                </p>
                                <button
                                    onClick={go}
                                    className="mt-5 inline-flex items-center gap-2 text-[12px] uppercase tracking-widest2 font-semibold text-ink hover:text-gold-600 transition-colors"
                                >
                                    Learn more
                                    <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
